import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-how-to-choose-an-ops-for-an-interactive-flat-panel',
  templateUrl: './how-to-choose-an-ops-for-an-interactive-flat-panel.component.html',
  styleUrls: ['./how-to-choose-an-ops-for-an-interactive-flat-panel.component.scss']
})
export class HowToChooseAnOpsForAnInteractiveFlatPanelComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('How to Choose an OPS for an Interactive Flat Panel | VIRSA');
    this.metaService.updateTag({
      name: 'description',
      content: 'Learn how to choose the right OPS for an Interactive Flat Panel. Compare processor, RAM, SSD storage, graphics, connectivity, compatibility, upgradeability and performance with VIRSA OPS solutions.'
    });
    this.metaService.updateTag({
      name: 'keywords',
      content: 'how to choose OPS for Interactive Flat Panel, best OPS for Interactive Flat Panel, OPS for smart classroom, OPS module for IFP, Open Pluggable Specification, Interactive Flat Panel OPS, Intel OPS for Interactive Panel, OPS for digital classroom, VIRSA OPS, best OPS for smart classroom, OPS computer for Interactive Flat Panel, i5 OPS for Interactive Panel, i7 OPS for Interactive Panel, i9 OPS for Interactive Panel, SSD OPS module, OPS module for education, Windows OPS for smart classroom, OPS compatibility with Interactive Flat Panel'
    });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
